import React, { useContext } from "react";
import { LinkValues } from "../values/strings";
import { useCoreRequestProvider } from "./RequestProvider";

const CurrencyContext = React.createContext();

export const CurrencyProvider = ({ children }) => {
  const [coinList, setCoinList] = React.useState([]);
  const [currentCurrency, setCurrentCurrency] = React.useState("IRT");
  const [intervalData, setIntervalData] = React.useState(null);
  const coreRequest = useCoreRequestProvider();

  React.useEffect(async () => {
    if (!intervalData) {
      await invokeCoinPrice();
      setIntervalData(
        setInterval(async () => {
          await invokeCoinPrice();
        }, 5000)
      );
    }
  }, [intervalData]);

  const invokeCoinPrice = async () => {
    const data = await coreRequest.get(
      LinkValues.core.blockchain.token.list(),
      {
        pair_symbol: currentCurrency,
      }
    );
    if (data.data && data.data.data) {
      setCoinList(data.data.data);
    }
  };

  return (
    <CurrencyContext.Provider
      value={{
        coinList,
        currentCurrency,
        setCurrentCurrency,
      }}
    >
      {children}
    </CurrencyContext.Provider>
  );
};

export const useCurrencyProvider = () => {
  return useContext(CurrencyContext);
};
